import type { CosmicHeaderColumn } from '@/lib/cms/cosmic/types/CosmicHeaderType'
import { useGTM } from '@/lib/hooks/google-analytics/useGTM'
import useParseLinkUrlWithLocale from '@/lib/hooks/routing/useParseLinkUrlWithLocale'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'
import { cn } from '@/lib/utils'

type Props = {
  columns: [CosmicHeaderColumn, CosmicHeaderColumn?, CosmicHeaderColumn?]
}

const DesktopMenuColumns = ({ columns }: Props) => {
  const { parseLinkUrlWithLocale } = useParseLinkUrlWithLocale()
  const { gtm } = useGTM()

  return (
    <div className={`grid-cols-${columns.length} pointer-events-auto grid`}>
      {columns.map((column) => (
        <div key={`${column?.title}`}>
          <span className="text-sm text-secondary">{column?.title}</span>
          <div
            className={cn(
              ' mt-5 flex flex-col gap-4 ',
              // column?.bold && 'text-lg font-bold', // TODO: Cosmic does not return the bold property
            )}
          >
            {column?.items?.map((item) => (
              <a
                onClick={() => {
                  gtm.navbarMenuItemClicked({
                    action: item.title,
                    category: column.title,
                  })

                  mixpanelService
                    .trackEvent(
                      MixpanelEvent.NAVIGATION_BAR_SHOP_MENU_ITEM_CLICKED,
                      {
                        action:
                          (item.href.at(-1) === '/'
                            ? item.href.split('/').at(-2)
                            : item.href.split('/').at(-1)) || '',
                        category: column.title,
                      },
                    )
                    .catch(() => {})
                }}
                className="text-primary no-underline hover:underline"
                key={item.title}
                href={parseLinkUrlWithLocale({ url: item.href })}
              >
                {item.title}
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default DesktopMenuColumns
